export const getPagesList = (state) => state.towerSideProfile.pagesList
